import { PIM_HISTORY_ACTION_TYPES } from './pim-history.type';
import { IPIMHistoryEntry, IPIMHistoryFilters, IPIMHistoryState } from '../types/pim-history.interface';

type SetLoadingAction = { type: typeof PIM_HISTORY_ACTION_TYPES.SET_LOADING; payload: boolean };
type SetErrorAction = { type: typeof PIM_HISTORY_ACTION_TYPES.SET_ERROR; payload: string | null };
type SetEntriesAction = {
  type: typeof PIM_HISTORY_ACTION_TYPES.SET_ENTRIES;
  payload: { entries: IPIMHistoryEntry[]; total: number; page: number; limit: number; append?: boolean };
};
type SetFiltersAction = { type: typeof PIM_HISTORY_ACTION_TYPES.SET_FILTERS; payload: Partial<IPIMHistoryFilters> };
type ResetAction = { type: typeof PIM_HISTORY_ACTION_TYPES.RESET };

type PIMHistoryAction = SetLoadingAction | SetErrorAction | SetEntriesAction | SetFiltersAction | ResetAction;

const initialState: IPIMHistoryState = {
  entries: [],
  total: 0,
  page: 1,
  limit: 25,
  filters: {},
  loading: false,
  error: null,
  hasMore: false,
};

/* eslint-disable default-param-last */
const PIMHistoryReducer = (state: IPIMHistoryState = initialState, action: PIMHistoryAction): IPIMHistoryState => {
  switch (action.type) {
    case PIM_HISTORY_ACTION_TYPES.SET_LOADING:
      return { ...state, loading: action.payload };
    case PIM_HISTORY_ACTION_TYPES.SET_ERROR:
      return { ...state, error: action.payload, loading: false };
    case PIM_HISTORY_ACTION_TYPES.SET_ENTRIES: {
      const nextEntries = action.payload.append
        ? [...state.entries, ...action.payload.entries]
        : action.payload.entries;
      return {
        ...state,
        entries: nextEntries,
        total: action.payload.total,
        page: action.payload.page,
        limit: action.payload.limit,
        hasMore: nextEntries.length < action.payload.total,
        error: null,
      };
    }
    case PIM_HISTORY_ACTION_TYPES.SET_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };
    case PIM_HISTORY_ACTION_TYPES.RESET:
      return initialState;
    default:
      return state;
  }
};

export default PIMHistoryReducer;
